import Vue from 'vue';
import ApolloClient, { InMemoryCache, HttpLink } from 'apollo-boost';
import VueApollo from 'vue-apollo';

export const apolloClient = new ApolloClient({
	uri:
		process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev'
			? `${process.env.VUE_APP_LOCAL_API_URL}/v1/graphql`
			: `${process.env.VUE_APP_API_URL}/v1/graphql`,
	request: operation => {
		operation.setContext({
			headers: {
				'x-hasura-admin-secret': process.env.VUE_APP_API_SECRET,
			},
		});
	},
});

Vue.use(VueApollo);

console.log(`NODE_ENV: ${process.env.NODE_ENV}`);

export const apolloProvider = new VueApollo({
	defaultClient: apolloClient,
});
